import { useTranslation } from "react-i18next";
import { formatDateTime } from "../door-access-utils";

const MINUTE = 60 * 1000;

/** "2 min ago", "3 hours ago"... keyed through i18n so es reads naturally. */
export const useAgo = () => {
  const { t } = useTranslation("coaching-portal");
  return (value, now = new Date()) => {
    const minutes = Math.max(
      0,
      Math.floor((now.getTime() - new Date(value).getTime()) / MINUTE)
    );
    if (minutes < 1) return t("doorAccess.ago.justNow");
    if (minutes < 60) return t("doorAccess.ago.minutes", { count: minutes });
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t("doorAccess.ago.hours", { count: hours });
    return t("doorAccess.ago.days", { count: Math.floor(hours / 24) });
  };
};

const ConnectionPill = ({ status }) => {
  const { t } = useTranslation("coaching-portal");
  const ago = useAgo();

  if (!status.connected) {
    return (
      <span className="door-pill" data-tone="default">
        {t("doorAccess.connection.notConnected")}
      </span>
    );
  }
  if (!status.lastEventAt) {
    return (
      <span className="door-pill" data-tone="info">
        <i className="door-live" />
        {t("doorAccess.connection.waiting")}
      </span>
    );
  }
  if (status.connectionQuiet) {
    return (
      <span
        className="door-pill"
        data-tone="warning"
        title={t("doorAccess.connection.quietTip", {
          when: formatDateTime(status.lastEventAt, status.timeZone),
        })}
      >
        <i className="door-live" />
        {t("doorAccess.connection.quiet")}
      </span>
    );
  }
  return (
    <span className="door-pill" data-tone="success">
      <i className="door-live" />
      {t("doorAccess.connection.connected", { ago: ago(status.lastEventAt) })}
    </span>
  );
};

export default ConnectionPill;
